export default __webpack_public_path__ + "static/media/mean-icon.12eb4a15.svg";